// extracted by mini-css-extract-plugin
export default {"HeaderWrapper":"CountryReport_HeaderWrapper__mtsqA","MapWrapper":"CountryReport_MapWrapper__nmMev"};